module.exports = __webpack_public_path__ + "media/images/sp/stores/namba/namba_sns_04-5466654866fcc41ef1e433590d72e6fb.jpg";